import { useState } from "react";
import API from "../api";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [form, setForm] = useState({});
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  const submit = async () => {
    try {
      const res = await API.post("/auth/login", form);
      localStorage.setItem("token", res.data.token);
      window.location = "/";
    } catch (e) {
      setMsg("Belépési hiba vagy admin jóváhagyás kell.");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      submit();
    }
  };
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="bg-white shadow p-8 rounded w-96">
        <h2 className="text-xl mb-4">Bejelentkezés</h2>

        <input
          placeholder="Username"
          className="border p-2 mb-2 w-full"
          onChange={(e) =>
            setForm({ ...form, username: e.target.value })
          }
          onKeyPress={handleKeyPress}
        />

        <input
          type="password"
          placeholder="Password"
          className="border p-2 mb-2 w-full"
          onChange={(e) =>
            setForm({ ...form, password: e.target.value })
          }
          onKeyPress={handleKeyPress}
        />

        <button
          className="bg-blue-600 text-white p-2 w-full"
          onClick={submit}
        >
          Login
        </button>

        <div className="text-red-500 mt-2">{msg}</div>

        <div
          className="mt-4 text-blue-600 cursor-pointer"
          onClick={() => navigate("/register")}
        >
          Regisztráció
        </div>
      </div>
    </div>
  );
}